export const EnvelopeDarkIcon: React.FC = () => {
	return (
		<svg
			fill="none"
			height="24"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_352_518)">
				<path
					d="M21.5533 4C21.4625 3.99064 21.3709 3.99064 21.28 4H2.61334C2.49371 4.00185 2.37486 4.01979 2.26001 4.05334L11.8933 13.6467L21.5533 4Z"
					fill="#212B36"
				/>
				<path
					d="M22.54 4.9267L12.8333 14.5934C12.5835 14.8417 12.2455 14.9811 11.8933 14.9811C11.541 14.9811 11.2031 14.8417 10.9533 14.5934L1.33329 5.00003C1.30371 5.10872 1.28803 5.22073 1.28662 5.33336V18.6667C1.28662 19.0203 1.4271 19.3595 1.67715 19.6095C1.92719 19.8596 2.26633 20 2.61995 20H21.2866C21.6402 20 21.9794 19.8596 22.2294 19.6095C22.4795 19.3595 22.62 19.0203 22.62 18.6667V5.33336C22.6146 5.19447 22.5877 5.05725 22.54 4.9267ZM3.53329 18.6667H2.60662V17.7134L7.45329 12.9067L8.39329 13.8467L3.53329 18.6667ZM21.2733 18.6667H20.34L15.48 13.8467L16.42 12.9067L21.2666 17.7134L21.2733 18.6667Z"
					fill="#212B36"
				/>
			</g>
			<defs>
				<clipPath id="clip0_352_518">
					<rect fill="red" height="24" width="24" />
				</clipPath>
			</defs>
		</svg>
	);
};
